export default __webpack_public_path__ + "static/media/rupeefill.c4987a75.svg";